import { AttachmentInterface } from '@/types/interfaces'

export const flattenedAttachments = (attachments: Array<AttachmentInterface>) : Array<AttachmentInterface> => {
  return attachments.reduce((uploads: Array<AttachmentInterface>, attachment: AttachmentInterface) => {
    // 🚨 Recursive Function!
    const subAttachments = (attachment.subAttachments && attachment.subAttachments.length > 0) ? flattenedAttachments(attachment.subAttachments) : []
    return uploads.concat(attachment, subAttachments)
  }, [])
}

export const flattenedAttachmentsWithoutParent = (attachments: Array<AttachmentInterface>) : Array<AttachmentInterface> => {
  return attachments.reduce((uploads: Array<AttachmentInterface>, attachment: AttachmentInterface) => {
    // 🚨 Recursive Function!
    const attachmentsToAdd = (attachment.subAttachments && attachment.subAttachments.length > 0) ? flattenedAttachmentsWithoutParent(attachment.subAttachments) : attachment
    return uploads.concat(attachmentsToAdd)
  }, [])
}